import React from 'react';
import Styled from 'styled';
import { observer } from 'mobx-react';
import Localizable from 'lib/intl/localizable';
import defaultStyles from './box-view.scss';

@Localizable()
@Styled(defaultStyles)
@observer
class BoxView extends React.Component {
    render() {
        const { styles, hoverable, onClick, mini } = this.props;

        const classNames = [styles.box];

        if (mini) {
            classNames.push(styles.mini);
        }

        if (hoverable) {
            classNames.push(styles.hoverable);
        }

        if (onClick) {
            classNames.push(styles.clickable);
        }

        return React.createElement(
            onClick ? 'button' : 'span',
            { onClick, className: classNames.join(' ') },
            this.props.children
        );
    }
}

export default BoxView;
